const pattern = /(?:\.)([a-z0-9]{2,4})$/i;

export default pattern;